<template>
  <div class="text-page">
    <a v-on:click="leavePage()">
      <img class="close-icon" src="../assets/img/close-icon.svg" />
    </a>
    <h2 class="h2-custom">Oppdatert status 2023</h2>
    <p>250 ville laksebestander er nå klassifisert med hensyn til genetisk innkryssing av rømt oppdrettslaks.
      Laksebestandene som er undersøkt representerer 95 % av den samlede villaksressursen i Norge. Den genetiske
      statusen fordeler seg slik på fire tilstandsklasser: </p>

    <p>
      <div><span class="label green">Grønn</span> (tilstand svært god eller god): Ingen genetiske endringer observert – 82 bestander (32,8 %)</div>
      <div><span class="label yellow">Gul</span> (tilstand moderat): Svake genetiske endringer indikert – 70 bestander (28,0 %)</div>
      <div><span class="label orange">Orange</span>  (tilstand dårlig): Moderate genetiske endringer er påvist – 21 bestander (8,4 %)</div>
      <div><span class="label red">Rød</span> (tilstand svært dårlig): Store genetiske endringer er påvist – 77 bestander (30,8 %).</div>
    </p>

    <p>Alle 52 vassdrag som er definert som Nasjonale laksevassdrag (NLV) er klassifisert. Vi har definert Stordalselva
      og Norddalselva i Åfjord kommune som to ulike vassdrag og Steinkjervassdraget er delt opp i Ogna og Steinkjerelva.
      Etter denne definisjonen fordeler de 54 nasjonale laksevassdragene seg slik til de ulike tilstandsklassene:
      Grønn: 15 (27,8 %), Gul: 15 (27,8 %), Oransje: 8 (14,8 %), Rød: 16 (29,6 %). </p>
    <p>
      For flere detaljerte resultater, blant annet endringer i status i forhold til tidligere klassifisering og genetisk status oppsummert per produksjonsområde, henvises til 
      <a href="https://brage.nina.no/nina-xmlui/handle/11250/3108558" target="_blank">NINA rapport 2393</a>.  
    </p>

  </div>
</template>

<script>
import router from "../router.js";

export default {
  name: "Status",
  props: {
    msg: String
  },
  methods: {
    leavePage() {
      router.push({ name: "watercourses" });
    }
  }
};
</script>
